import {createYandexMapHelper} from '../../classes/yandex-map-helper/yandex-map-helper/init-yandex-map';
import {YMAPS_API_KEY} from '../../classes/yandex-map-helper/constants';

const CONTACTS_OBJECT_MANAGER = 'contacts-object-manager';

const DATA_MAP_JSON = 'data-map-json';

const DATA_CONTACT_ID_ATTRIBUTE = 'data-contact-id';

const ACTIVE_CLASS = 'active';

const initTabs = ( yandexMapHelper, contacts ) => {
	const tabsWrapper = yandexMapHelper.component.querySelector( 'ul.tabs' );
	const contactsWrapper = yandexMapHelper.component.querySelector( 'ul.contacts-list' );

	const contactsManager = yandexMapHelper.createObjectManager( CONTACTS_OBJECT_MANAGER, {} );

	Object.entries( contacts ).forEach( ( [id, contact] ) => {
		const {longitude, latitude, name} = contact;

		const placemarkHeight = 58;
		const placemarkWidth = 63;

		const placemarkProps = {
			type: 'Feature',
			id,
			geometry: {
				type: 'Point',
				coordinates: [latitude, longitude],
			},
			properties: {
				hintContent: name,
			},
			options: {
				iconLayout: 'default#image',
				iconImageHref: '/styles/images/components/contacts/icon.svg',
				iconImageSize: [placemarkWidth, placemarkHeight],
				iconImageOffset: [-0.5 * placemarkWidth, -1 * placemarkHeight],
			},
		};

		contactsManager.add( placemarkProps );
	} );

	const setNewMapCenter = ( contactId, duration = 400 ) => {
		if ( !contactId )
		{
			return;
		}

		const contact = contacts[contactId];

		if ( !contact )
		{
			return;
		}

		const {longitude, latitude} = contact;

		if ( !longitude || !latitude )
		{
			return;
		}

		yandexMapHelper.yandexMap.setCenter(
			[latitude, longitude],
			yandexMapHelper.initZoom,
			{checkZoomRange: false, duration, useMapMargin: true},
		);
	};

	const initActiveButton = tabsWrapper.querySelector( `button.${ACTIVE_CLASS}[${DATA_CONTACT_ID_ATTRIBUTE}]` );

	if ( initActiveButton )
	{
		setNewMapCenter( initActiveButton.getAttribute( DATA_CONTACT_ID_ATTRIBUTE ), 0 );
	}

	tabsWrapper.addEventListener( 'click', ( evt ) => {
		const button = evt.target.closest( `button[${DATA_CONTACT_ID_ATTRIBUTE}]` );

		if ( button )
		{
			const newActiveContactId = button.getAttribute( DATA_CONTACT_ID_ATTRIBUTE );

			if ( !newActiveContactId )
			{
				return;
			}

			const newActiveContact = contactsWrapper.querySelector( `li[${DATA_CONTACT_ID_ATTRIBUTE}="${newActiveContactId}"]` );

			if ( !newActiveContact )
			{
				return;
			}

			tabsWrapper.querySelectorAll( `button.${ACTIVE_CLASS}` ).forEach( ( activeTab ) => activeTab.classList.remove( ACTIVE_CLASS ) );
			contactsWrapper.querySelectorAll( `li.${ACTIVE_CLASS}` ).forEach( ( activeContact ) => activeContact.classList.remove( ACTIVE_CLASS ) );

			button.classList.add( ACTIVE_CLASS );
			newActiveContact.classList.add( ACTIVE_CLASS );

			setNewMapCenter( newActiveContactId );
		}
	} );
};

const initMap = ( yandexMapHelper ) => {
	yandexMapHelper.addZoomControls( {
		position: {
			top: 20,
			right: 20,
			bottom: 'auto',
			left: 'auto',
		},
	} );
	yandexMapHelper.setCorrectScrolling();
	
	yandexMapHelper.yandexMap.margin.addArea( {
		left: 0,
		bottom: 0,
		width: '100%',
		height: 100,
	} );
	yandexMapHelper.yandexMap.margin.addArea( {
		top: 0,
		left: 0,
		width: '100%',
		height: 100,
	} );
	yandexMapHelper.yandexMap.margin.addArea( {
		top: 0,
		left: 0,
		width: 40,
		height: '100%',
	} );
	yandexMapHelper.yandexMap.margin.addArea( {
		top: 0,
		right: 0,
		width: 40,
		height: '100%',
	} );
	
	const mapWrapper = yandexMapHelper.component.querySelector( 'div.map-wrapper' );
	
	if ( !mapWrapper )
	{
		return;
	}
	
	const mapJSON = JSON.parse( mapWrapper.getAttribute( DATA_MAP_JSON ) );
	
	if ( !mapJSON )
	{
		return;
	}
	
	mapWrapper.removeAttribute( DATA_MAP_JSON );
	
	initTabs( yandexMapHelper, mapJSON );
};

const initContacts = () => {
	document.querySelectorAll( 'section.contacts' ).forEach( ( component ) => {
		const mapContainer = component.querySelector( 'div.map-wrapper' );
		
		if ( mapContainer )
		{
			const mapProps = {
				ymapsApiKey: YMAPS_API_KEY,
				mapContainer,
				mapState: {
					zoom: 16,
				},
				component,
				readyCallback: initMap,
			};
			
			createYandexMapHelper( mapProps );
		}
	} );
};

export {
	initContacts,
};
